import styled from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function ShippingNotice() {
  return (
    <ShippingNoticeBlock>
      <IconBlock>
        <SVGIcon name="infoCircleIcon" />
      </IconBlock>
      <ShippingNoticeParagraph>
        {`주문 후에는 배송지 변경이 불가능합니다.\n정확히 배송지를 입력해주세요.`}
      </ShippingNoticeParagraph>
    </ShippingNoticeBlock>
  )
}

const ShippingNoticeBlock = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: calc(100vw * (8 / 375)) calc(100vw * (14 / 375));
  border-radius: calc(100vw * (5 / 375));
  background-color: #f7f7f7;
  margin-bottom: calc(100vw * (25 / 375));
`

const IconBlock = styled.div`
  width: calc(100vw * (18 / 375));
  height: calc(100vw * (18 / 375));
  margin-right: calc(100vw * (5.5 / 375));

  svg {
    color: #4e4e4e;
  }
`

const ShippingNoticeParagraph = styled.p`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (18 / 375));
  color: #4e4e4e;
  white-space: pre-wrap;
`
